// extracted by mini-css-extract-plugin
export default {"language_wrapper":"LanguageList_language_wrapper__av9YD","title":"LanguageList_title__OJhs-"};